export const siteMeta = {
  name: "瓜田爆料",
  slogan: "最新动静不过夜",
  subtitle: "独家首发 · 第一手 · 内部流出 · 抢先看",
  email: "tips@gutianbaoliao.com",
  contactTime: "线索处理：每天 09:00 - 23:00",
  description:
    "瓜田爆料是一个把爆料线索集中整理的资讯门户，从首发到后续反转都留下完整时间线，让想快人一步的人不用再东拼西凑。",
};

export const navAnchors = [
  { label: "首页", href: "#top" },
  { label: "今日首发", href: "#featured" },
  { label: "最新爆料", href: "#latest" },
  { label: "热度榜", href: "#ranking" },
  { label: "专题解读", href: "#columns" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export const heroTicker = [
  "古装剧《长夜归舟》收官夜临时删改片段，剪辑师透露被剪的是一场关键对峙",
  "巡回演唱会临时更换城市，主办方内部通知流出，退票通道同步开启",
  "综艺录制现场传出争执，节目组连夜发布情况说明",
  "电竞战队核心选手转会传闻升温，战队经理回应留下余地",
  "新晋小花新剧官宣前夜被换角，片方工作人员给出另一种说法",
  "头部主播突然停播三天，粉丝整理出账号异常登录时间线",
];

export const portalStats = [
  { value: "2,180", unit: "条", label: "累计收录爆料线索" },
  { value: "48", unit: "小时", label: "首发到后续跟进的平均间隔" },
  { value: "17", unit: "个", label: "长期跟踪的领域方向" },
  { value: "92", unit: "%", label: "带完整时间线的条目占比" },
];

export interface ArticleItem {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  tags: string[];
  publishedAt: string;
  reads: string;
  comments: number;
  cover: string;
  hot?: boolean;
  exclusive?: boolean;
  status: string;
}

export const featuredStories: ArticleItem[] = [
  {
    id: "f-01",
    title: "《长夜归舟》收官夜删改片段，剪辑师还原被剪掉的关键对峙",
    excerpt:
      "收官当晚，一段原本出现在预告里的对峙戏没有播出。参与后期的工作人员表示，改动发生在播出前不到六个小时，理由并不完全是时长问题。",
    category: "影视剧组",
    tags: ["独家首发", "剪辑线"],
    publishedAt: "18 分钟前",
    reads: "12.6 万",
    comments: 486,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20composition%20with%20deep%20crimson%20and%20midnight%20ink%20paper%20textures%2C%20torn%20film%20strip%20shapes%2C%20dramatic%20side%20lighting%2C%20high%20contrast%20negative%20space%2C%20grainy%20cinematic%20magazine%20cover%20aesthetic&width=1200&height=800&seq=gua-feature-01&orientation=landscape",
    exclusive: true,
    hot: true,
    status: "持续跟进",
  },
  {
    id: "f-02",
    title: "巡回演唱会临时换城，主办方内部通知在开票前两小时流出",
    excerpt:
      "原定场地在开票前两小时被临时替换，一份标注为内部使用的协调通知被转出，通知里提到的原因与官方公告并不一致。",
    category: "音乐现场",
    tags: ["内部流出", "票务"],
    publishedAt: "42 分钟前",
    reads: "9.3 万",
    comments: 312,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20stage%20light%20composition%20with%20warm%20amber%20beams%20and%20deep%20green%20silhouette%20shapes%2C%20ivory%20paper%20grain%2C%20long%20exposure%20motion%20streaks%2C%20editorial%20concert%20poster%20aesthetic%2C%20no%20people&width=1200&height=900&seq=gua-feature-02&orientation=landscape",
    exclusive: true,
    status: "等待回应",
  },
  {
    id: "f-03",
    title: "综艺录制现场传出争执录音，节目组深夜给出情况说明",
    excerpt:
      "一段据称来自录制现场的录音在凌晨传播，节目组随后发布情况说明，但说明中没有回答录音里最被关心的那句话。",
    category: "综艺录制",
    tags: ["连夜回应", "录音"],
    publishedAt: "1 小时前",
    reads: "15.1 万",
    comments: 729,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20sound%20wave%20motifs%20on%20warm%20ivory%20paper%20with%20vermilion%20accent%20lines%20and%20deep%20green%20blocks%2C%20editorial%20layout%20composition%2C%20soft%20studio%20lighting%2C%20magazine%20graphic%20style&width=1200&height=900&seq=gua-feature-03&orientation=landscape",
    hot: true,
    status: "持续跟进",
  },
];

export const latestArticles: ArticleItem[] = [
  {
    id: "a-01",
    title: "电竞战队核心选手转会传闻升温，战队经理回应只说了半句",
    excerpt: "传闻从一份报价单开始，战队经理在采访中承认沟通过，却没有否认报价金额。",
    category: "电竞圈",
    tags: ["转会"],
    publishedAt: "6 分钟前",
    reads: "4.2 万",
    comments: 138,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20esports%20themed%20graphic%20with%20deep%20green%20geometric%20panels%20and%20vermilion%20accent%20stripes%20on%20ivory%20paper%20texture%2C%20editorial%20minimal%20composition%2C%20soft%20shadow%2C%20no%20readable%20text&width=800&height=600&seq=gua-latest-01&orientation=landscape",
    hot: true,
    status: "待确认",
  },
  {
    id: "a-02",
    title: "新晋小花新剧官宣前夜被换角，片方工作人员给出另一种说法",
    excerpt: "官宣物料已经定稿，角色却在发布前一夜易主，两种解释在同一个剧组里同时存在。",
    category: "影视剧组",
    tags: ["换角"],
    publishedAt: "23 分钟前",
    reads: "7.8 万",
    comments: 264,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20casting%20board%20composition%20with%20warm%20ivory%20paper%2C%20vermilion%20bordered%20empty%20frames%2C%20deep%20green%20tape%20shapes%2C%20editorial%20flat%20lay%20aesthetic%2C%20no%20people&width=800&height=600&seq=gua-latest-02&orientation=landscape",
    status: "等待回应",
  },
  {
    id: "a-03",
    title: "头部主播突然停播三天，粉丝整理出账号异常登录时间线",
    excerpt: "停播公告只有一句话，但粉丝把登录记录、设备变更和开播取消时间拼成了一条完整线索。",
    category: "直播圈",
    tags: ["停播"],
    publishedAt: "51 分钟前",
    reads: "11.4 万",
    comments: 503,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20timeline%20graphic%20on%20warm%20ivory%20background%20with%20deep%20green%20nodes%20and%20vermilion%20markers%2C%20editorial%20data%20visual%20style%2C%20clean%20minimal%20layout&width=800&height=600&seq=gua-latest-03&orientation=landscape",
    hot: true,
    status: "持续跟进",
  },
  {
    id: "a-04",
    title: "音乐节压轴阵容临时变更，票务平台连夜开放退票通道",
    excerpt: "演出前一天下午名单更新，退票入口在凌晨上线，主办方尚未解释变更依据。",
    category: "音乐现场",
    tags: ["阵容变更"],
    publishedAt: "1 小时前",
    reads: "5.6 万",
    comments: 197,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20festival%20poster%20composition%20with%20amber%20gradient%20bands%20and%20deep%20ink%20green%20shapes%20on%20ivory%20paper%2C%20editorial%20print%20texture%2C%20no%20people&width=800&height=600&seq=gua-latest-04&orientation=landscape",
    status: "待确认",
  },
  {
    id: "a-05",
    title: "选秀成团名单疑似提前外泄，节目组紧急发布声明",
    excerpt: "一份带有内部编号的名单在投票截止前流出，节目组回应称正在核查来源。",
    category: "选秀舞台",
    tags: ["名单外泄"],
    publishedAt: "2 小时前",
    reads: "13.2 万",
    comments: 641,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20envelope%20and%20ranked%20list%20motif%20on%20warm%20ivory%20paper%20with%20vermilion%20seal%20shape%20and%20deep%20green%20stripes%2C%20editorial%20still%20life%2C%20no%20readable%20text&width=800&height=600&seq=gua-latest-05&orientation=landscape",
    exclusive: true,
    status: "等待回应",
  },
  {
    id: "a-06",
    title: "男团成员深夜点赞事件发酵，后援会要求公司给出核实结果",
    excerpt: "点赞在十二秒后取消，但截图已经传开。后援会的公开信里列出了三个待解释的问题。",
    category: "音乐现场",
    tags: ["账号动态"],
    publishedAt: "3 小时前",
    reads: "8.9 万",
    comments: 372,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20social%20notification%20bubbles%20in%20vermilion%20and%20amber%20on%20warm%20ivory%20paper%20with%20deep%20green%20accents%2C%20editorial%20minimal%20graphic%20composition&width=800&height=600&seq=gua-latest-06&orientation=landscape",
    status: "待确认",
  },
  {
    id: "a-07",
    title: "电影路演临时取消，发行方解释原因与天气无关",
    excerpt: "三个城市的场次在一小时内先后取消，发行方的说明只保留了一句话。",
    category: "影视剧组",
    tags: ["路演"],
    publishedAt: "4 小时前",
    reads: "6.1 万",
    comments: 208,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20city%20route%20map%20lines%20in%20deep%20green%20and%20vermilion%20on%20ivory%20paper%20texture%2C%20editorial%20infographic%20style%2C%20minimal%20clean%20composition&width=800&height=600&seq=gua-latest-07&orientation=landscape",
    status: "等待回应",
  },
  {
    id: "a-08",
    title: "剧组场务爆料主演长期迟到，制片方内部通报被转出",
    excerpt: "通报里没有点名，但给出的时间记录精确到分钟，场务的另一份排班表与之对应。",
    category: "影视剧组",
    tags: ["内部流出"],
    publishedAt: "5 小时前",
    reads: "10.7 万",
    comments: 455,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20call%20sheet%20and%20clock%20motif%20on%20warm%20ivory%20paper%20with%20deep%20green%20grid%20and%20vermilion%20marker%2C%20editorial%20print%20aesthetic&width=800&height=600&seq=gua-latest-08&orientation=landscape",
    hot: true,
    status: "持续跟进",
  },
  {
    id: "a-09",
    title: "两家经纪公司同日发布声明，疑似就同一艺人归属产生分歧",
    excerpt: "两份声明相隔四十分钟，措辞谨慎，却都提到了同一份尚未公开的合约。",
    category: "综艺录制",
    tags: ["合约"],
    publishedAt: "6 小时前",
    reads: "7.3 万",
    comments: 289,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20two%20overlapping%20document%20shapes%20on%20warm%20ivory%20paper%20with%20deep%20green%20and%20vermilion%20accents%2C%20editorial%20minimal%20composition%2C%20soft%20studio%20light&width=800&height=600&seq=gua-latest-09&orientation=landscape",
    status: "待确认",
  },
];

export const hotRanking = [
  { rank: 1, id: "a-05", title: "选秀成团名单疑似提前外泄，节目组紧急发布声明", heat: "132.4 万", trend: "up" },
  { rank: 2, id: "f-03", title: "综艺录制现场传出争执录音，节目组深夜给出情况说明", heat: "118.9 万", trend: "up" },
  { rank: 3, id: "f-01", title: "《长夜归舟》收官夜删改片段，剪辑师还原关键对峙", heat: "106.2 万", trend: "same" },
  { rank: 4, id: "a-03", title: "头部主播突然停播三天，粉丝整理出异常登录时间线", heat: "94.7 万", trend: "up" },
  { rank: 5, id: "a-08", title: "剧组场务爆料主演长期迟到，制片方内部通报被转出", heat: "88.1 万", trend: "down" },
  { rank: 6, id: "f-02", title: "巡回演唱会临时换城，内部协调通知在开票前流出", heat: "81.5 万", trend: "up" },
  { rank: 7, id: "a-06", title: "男团成员深夜点赞事件发酵，后援会要求核实结果", heat: "76.3 万", trend: "same" },
  { rank: 8, id: "a-02", title: "新晋小花新剧官宣前夜被换角，片方给出另一种说法", heat: "69.8 万", trend: "down" },
];

export const topicCategories = [
  { name: "影视剧组", count: 386, icon: "ri-movie-2-line", desc: "定妆、换角、剪辑与片场的中间态" },
  { name: "音乐现场", count: 244, icon: "ri-mic-line", desc: "巡演、阵容变更与现场的第一时间动静" },
  { name: "综艺录制", count: 198, icon: "ri-live-line", desc: "录制现场的临时调整与回应" },
  { name: "电竞圈", count: 173, icon: "ri-gamepad-line", desc: "转会、阵容与赛训动态" },
  { name: "直播圈", count: 152, icon: "ri-broadcast-line", desc: "开播异常、停播与账号动态" },
  { name: "选秀舞台", count: 121, icon: "ri-award-line", desc: "投票、成团与外泄名单核查" },
];

export const featureColumns = [
  {
    id: "c-01",
    kicker: "专题 · 剪辑线",
    title: "从预告到正片：被删掉的镜头都去哪了",
    excerpt: "我们整理了近三个月里，预告与正片出现差异的 11 个案例，并标注了每一次改动的发生时间。",
    meta: "共 11 个案例 · 更新于 2 天前",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20film%20editing%20table%20composition%20with%20ivory%20paper%20strips%20in%20deep%20green%20and%20vermilion%2C%20editorial%20flat%20lay%2C%20soft%20directional%20light%2C%20no%20people&width=1000&height=700&seq=gua-column-01&orientation=landscape",
  },
  {
    id: "c-02",
    kicker: "专题 · 时间线",
    title: "爆料是怎么被拼出来的：一条线索的完整链路",
    excerpt: "从一条凌晨的私信，到可以被核对的时间线，中间要经过哪些环节，我们把流程公开了一遍。",
    meta: "核实流程 · 更新于 5 天前",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20flow%20diagram%20nodes%20and%20connection%20lines%20in%20deep%20green%20and%20amber%20on%20warm%20ivory%20paper%2C%20editorial%20infographic%20aesthetic%2C%20clean%20minimal&width=1000&height=700&seq=gua-column-02&orientation=landscape",
  },
];

export const faqList = [
  {
    q: "瓜田爆料的「独家首发」到底指什么？",
    a: "指这条线索由我们最先整理并公开，且附带了可核对的时间点或来源描述。凡是标注独家首发的条目，页面里都会写明我们是第几手、依据是什么，方便你自己判断。",
  },
  {
    q: "内容多久更新一次？",
    a: "热点类线索按小时更新，首屏与热度榜在每天 09:00、15:00、22:00 三个时段集中整理；出现明确反转时不受时段限制，随时补充。",
  },
  {
    q: "怎么判断一条爆料是不是可靠？",
    a: "我们会在条目里标注状态，比如待确认、等待回应、持续跟进。只写情绪没有依据的内容不会被收录，反转出现时也会在原条目上补充，而不是悄悄改掉。",
  },
  {
    q: "可以投稿或者提供线索吗？",
    a: "可以。把你能提供的时间、截图和描述整理清楚，发送到页面底部的联系邮箱即可。我们更看重可核对的细节，而不是结论本身。",
  },
  {
    q: "为什么有些内容会突然补充后续？",
    a: "很多事件在首发时并不完整。我们把每一次补充都留在同一条时间线上，这样你先看前情、再看反转，不会被旧的截图误导。",
  },
  {
    q: "关注哪些方向能第一时间看到更新？",
    a: "如果你只想看最新的，订阅页面底部的首发推送，或者在热度榜里挑一个方向长期跟踪。订阅只推送发生变化的条目，不会每天轰炸你。",
  },
];

export const reputations = [
  {
    name: "追剧不落排",
    role: "三年老读者",
    text: "以前追一个瓜要翻七八个地方，现在时间线都排好了，前情和后续在一起，省事太多了。",
  },
  {
    name: "夜班摸鱼选手",
    role: "夜场常客",
    text: "凌晨刷到首发，第二天上班同事们还在讨论旧版本，我已经知道后续反转了。",
  },
  {
    name: "只信细节的人",
    role: "内容研究者",
    text: "难得的是它会写清楚依据和状态，哪些是待确认、哪些有回应，不会用情绪替你做判断。",
  },
];

export const footerLinks = [
  {
    title: "内容板块",
    links: [
      { label: "今日首发", href: "#featured" },
      { label: "最新爆料", href: "#latest" },
      { label: "热度榜", href: "#ranking" },
      { label: "专题解读", href: "#columns" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "网站介绍", href: "#about" },
      { label: "内容原则", href: "#about" },
      { label: "用户口碑", href: "#about" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    title: "参与方式",
    links: [
      { label: "提供线索", href: "#about" },
      { label: "订阅推送", href: "#subscribe" },
      { label: "联系我们", href: "#about" },
      { label: "回到顶部", href: "#top" },
    ],
  },
];